import React from 'react';
import { Button } from "@/components/ui/button";
import { Download, RefreshCw, KeyRound } from "lucide-react";
import { useCotiPluginContext } from "@/context/PrivacyBridgeContext";

const InstallMetaMaskModal = () => {
    const { showInstallModal, setShowInstallModal, setShowCotiWalletAesKeyModal } = useCotiPluginContext();

    if (!showInstallModal) return null;

    const handleUseCotiWallet = () => {
        setShowInstallModal(false);
        setShowCotiWalletAesKeyModal(true);
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-transparent p-4">
            <div className="rounded-[24px] glass-panel p-6 md:p-12 max-w-md w-full text-center relative overflow-hidden shadow-2xl">
                {/* Close Button */}
                <button
                    onClick={() => setShowInstallModal(false)}
                    className="absolute top-4 right-4 text-muted-foreground hover:text-foreground transition-colors"
                >
                    ✕
                </button>

                <div className="w-20 h-20 rounded-full bg-destructive/20 border-2 border-destructive/50 flex items-center justify-center mx-auto mb-6">
                    <img src="/metamask-logo.svg" alt="MetaMask" className="w-12 h-12" onError={(e) => {
                        e.currentTarget.style.display = 'none';
                        e.currentTarget.parentElement!.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="text-destructive"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>';
                    }} />
                </div>

                <h2 className="text-2xl font-bold text-foreground mb-2">MetaMask Required</h2>
                <p className="text-sm text-muted-foreground mb-8">
                    Complete the steps below to install and activate MetaMask in your browser.
                </p>

                <div className="relative z-10 mb-6 max-w-sm mx-auto">
                    <div className="flex flex-col items-start">
                        {/* Step 1 */}
                        <div className="flex items-center gap-4 w-full">
                            <span className="flex-shrink-0 flex h-8 w-8 items-center justify-center rounded-full border border-border bg-muted text-sm font-semibold text-muted-foreground">1</span>
                            <Button
                                className="flex-grow bg-[#f6851b] hover:bg-[#e2761b] text-white font-bold h-12"
                                onClick={() => window.open('https://metamask.io/download/', '_blank')}
                            >
                                <Download className="mr-2 h-4 w-4" />
                                Install MetaMask
                            </Button>
                        </div>

                        {/* Connector Line */}
                        <div className="ml-4 w-px h-8 step-line" />

                        {/* Step 2 */}
                        <div className="flex items-center gap-4 w-full">
                            <span className="flex-shrink-0 flex h-8 w-8 items-center justify-center rounded-full border border-border bg-muted text-sm font-semibold text-muted-foreground">2</span>
                            <Button
                                className="flex-grow bg-muted hover:bg-foreground/10 text-foreground font-bold h-12"
                                onClick={() => window.location.reload()}
                            >
                                <RefreshCw className="mr-2 h-4 w-4" />
                                Activate MetaMask
                            </Button>
                        </div>
                    </div>
                </div>

                {/* Divider */}
                <div className="flex items-center gap-3 mb-6">
                    <div className="h-px flex-1 bg-muted" />
                    <span className="text-xs text-red-500 font-semibold">or</span>
                    <div className="h-px flex-1 bg-muted" />
                </div>

                {/* Alternative: Use COTI Wallet */}
                <Button
                    className="w-full btn-gradient-connect font-bold h-12"
                    onClick={handleUseCotiWallet}
                >
                    <KeyRound className="mr-2 h-4 w-4" />
                    Use COTI Wallet
                </Button>

                {/* Background Glows */}
                <div className="absolute top-0 right-0 w-80 h-80 bg-blue-500/10 rounded-full blur-[100px] -translate-y-1/2 translate-x-1/2 pointer-events-none" />
                <div className="absolute bottom-0 left-0 w-80 h-80 bg-purple-500/10 rounded-full blur-[100px] translate-y-1/2 -translate-x-1/2 pointer-events-none" />
            </div>
        </div>
    );
};

export default InstallMetaMaskModal;
